//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapActions} from 'vuex'
import Theme from '@/listing-app/mixins/Theme'
export default {
	name: "Property",
  data() {
    return {};
  },
  props: ["data"],
	mixins: [Theme],
  methods: {
		...mapActions(["set"]),
    loadDetail(api) {
			this.set({muta: 'detailApi', data: api})
      this.$router.push('detail')
    }
  }
};
